
<form [formGroup]="CreditCardForm_login" (ngSubmit)="onSubmit()">


    <div class="row">
        <div class="col-6 " style="margin-top:10px;" appearance="outline">

            <mat-label class="newLabelSize" style="font-size:14px;">First Name
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="do-not-autofill"
                    (keypress)="lettersOnly($event)" type="text" matInput formControlName="firstName"
                    style="border:none !important;">
                <mat-error *ngIf="submitted && f['firstName'].errors">

                </mat-error>
            </mat-form-field>
            <div *ngIf="submitted && f['firstName'].errors" class="validclass">
                <div *ngIf="f['firstName'].errors && f['firstName'].errors['required']">Name is
                    required.</div>
            </div>

        </div>
        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Last Name
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput
                    formControlName="lastName" style="border:none !important;"
                    (keypress)="lettersOnly($event)">


            </mat-form-field>
            <div *ngIf="submitted && f['lastName'].errors" class="validclass">
                <div *ngIf="f['lastName'].errors && f['lastName'].errors['required']">Last Name is
                    required.</div>
            </div>
        </div>

        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Email
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="do-not-autofill" type="email" matInput formControlName="email" style="border:none !important;" >


            </mat-form-field>
            <div *ngIf="submitted && f['email'].errors" class="validclass">
                    <div *ngIf="f['email'].errors['required']">Email is required.</div>
                        <div *ngIf="f['email'].errors['pattern']">Email is invalid</div>
            </div>
        </div>

        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Mobile Number
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="do-not-autofill" maxlength="10" type="text" matInput
                    formControlName="phone" style="border:none !important;" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                    >


            </mat-form-field>
            <div *ngIf="submitted && f['phone'].errors" class="validclass">
                <div *ngIf="f['phone'].errors && f['phone'].errors['required']">Mobile Number is
                    required.</div>
                    <div *ngIf="f['phone'].errors && f['phone'].errors['minlength']">Mobile number length must be 10
                        required.</div>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-12">
            <mat-label class="newLabelSize" style="font-size:14px;">Card Number</mat-label>
            <mat-form-field style="display: contents;" appearance="outline">
                <input class="newLabelSize" type="text" autocomplete="doNotAutoComplete"
                    (keyup)="GetCardType($event.target.value)" formControlName="cardNum"
                    onkeypress='return event.charCode >= 48 && event.charCode <= 57' matInput maxlength="16"
                    placeholder="XXXX-XXXX-XXXX-XXXX">
    
            </mat-form-field>
            <div *ngIf="submitted && f['cardNum'].errors" class="validclass">
                <div *ngIf="f['cardNum'].errors['required']">Card Number is required.</div>
            </div>
            <div *ngIf="f['cardNum'].errors && f['cardNum'].errors['pattern']" class="validclass">You must
                enter 16
                digits.</div>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <mat-label class="newLabelSize" style="font-size:14px;">Expiry Month
            </mat-label>
            <mat-form-field style="display: contents;" appearance="outline">
                <select matNativeControl formControlName="month" id="selectMonth">
                    <option disabled selected>Select</option>
                    <option *ngFor="let month of monthlist" [value]="month.value">{{month.text}}
                    </option>
                </select>

            </mat-form-field>
            <div *ngIf="submitted && f['month'].errors" class="validclass">
                <div *ngIf="f['month'].errors && f['month'].errors['required']">Month is
                    required.</div>

            </div>
        </div>
        <div class="col-4">
            <mat-label class="newLabelSize" style="font-size:14px;">Expiry Year
            </mat-label>
            <mat-form-field style="display: contents;" appearance="outline">
                <select matNativeControl formControlName="year" id="selectMonth1">
                    <option disabled selected>Select</option>
                    <option *ngFor="let year of years" [value]="year.value">
                        {{year.text}}</option>
                </select>

            </mat-form-field>
            <div *ngIf="submitted && f['year'].errors" class="validclass">
                <div *ngIf="f['year'].errors && f['year'].errors['required']">Year is required.
                </div>

            </div>
        </div>
        <div class="col-4" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">CVV</mat-label>
            <mat-form-field style="display: contents;">
                <input type="text" appMask (keyup)="cvvInput($event.target.value)" class="newLabelSize"
                    autocomplete="doNotAutoComplete"
                    onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                    formControlName="cvv" matInput #userCvv maxlength="3"
                    style="border:none !important;">
                <mat-hint align="end">{{userCvv.value?.length || 0}}/3</mat-hint>

            </mat-form-field>
            <div class="validclass" *ngIf="userCvv.value?.length !=0 && submitted && userCvv.value?.length < 3">You must
                enter 3
                digits.</div>
            <div *ngIf="submitted && f['cvv'].errors" class="validclass">
                <div *ngIf="f['cvv'].errors && f['cvv'].errors['required']">CVV is required.</div>


            </div>
        </div>
    </div>
    
    

    <div class="row">

        <div class="col-8" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Street Address
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="off" type="text" matInput
                    formControlName="street" style="border:none !important;"
                    (keypress)="firstLaterCaps($event)">

            </mat-form-field>
            <div *ngIf="submitted && f['street'].errors" class="validclass">
                <div *ngIf="f['street'].errors && f['street'].errors['required']">Street Address is
                    required.</div>

            </div>
        </div>
        <div class="col-4" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Apt/Suite #
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="off" type="text" matInput
                    formControlName="apartment" style="border:none !important;"
                    (keypress)="spaceNotAllowed($event)">

            </mat-form-field>

        </div>

        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">City</mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="off" type="text" matInput
                    formControlName="city" style="border:none !important;"
                    (keypress)="firstLaterCaps($event)">

            </mat-form-field>
            <div *ngIf="submitted && f['city'].errors" class="validclass">
                <div *ngIf="f['city'].errors && f['city'].errors['required']">City is required.</div>

            </div>
        </div>

        <div class="col-6" style="margin-top:13px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Province</mat-label>
            <mat-form-field style="display: contents;" appearance="outline">
                <select matNativeControl formControlName="state" id="selectMonth2">
                    <option disabled selected>Select</option>
                    <option *ngFor="let statelists of statelist" [value]="statelists.value">
                        {{statelists.text}}</option>
                </select>


            </mat-form-field>
            <div *ngIf="submitted && f['state'].errors" class="validclass">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">State is required.</div>

            </div>
        </div>

        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Country</mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="off" type="text" matInput
                    formControlName="country" style="border:none !important;" readonly>


            </mat-form-field>
        </div>
        <div class="col-6" style="margin-top:10px;" appearance="outline">
            <mat-label class="newLabelSize" style="font-size:14px;">Postal Code
            </mat-label>
            <mat-form-field style="display: contents;">
                <input class="newLabelSize" autocomplete="off" (keyup)="onKeyUp($event,'zip')"
                    type="text" matInput maxlength="6" formControlName="zip"
                    style="border:none !important; text-transform: capitalize;"
                    (paste)="onPaste($event)"  (keypress)="spaceNotAllowed($event)">


            </mat-form-field>
            <div *ngIf="submitted && f['zip'].errors" class="validclass">
                <div *ngIf="f['zip'].errors && f['zip'].errors['required']">Postal Code is required.
                </div>

                <div *ngIf="f['zip'].errors['pattern']">Minumum length should be 6 characters.</div>

            </div>
        </div>

        <div class="col-12">
            <div class="outerDefault">
                <input type="checkbox" class="checkboxdefault" formControlName="isDefault"> <span class="DeafaultText">Set Default Card</span>

            </div>
        </div>
    </div>


    <div class="form-footer">
        <button type="submit" class="btn btn-outline-primary-2"
            style="width: 100%; background-color: black; color: white;height: 47px;">
            <span>Save Card</span>
        </button>
    </div>

</form>
           